module.exports = __webpack_public_path__ + "media/flags/003-switzerland-cbe9a795.svg";